import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dashboard, RoleItem } from './attendance.types';

@Component({
  selector: 'app-attendance-history', standalone: true,
  imports: [CommonModule],
  templateUrl: './attendance-history.component.html',
  styleUrls: ['./attendance-common.css', './attendance-history.component.css'],
})
export class AttendanceHistoryComponent {
  @Input() items: Dashboard['history'] = [];
  @Input() additionRoles: RoleItem[] = [];

  historyLabel(item: Dashboard['history'][number]): string {
    const types: Record<string,string> = { actual: '当日実績', answer: '事前回答', target_add: '対象者追加', target_exclude: '対象者除外', roster_start: '受付開始', settings: '設定変更', finalize: '実績確定' };
    Object.assign(types,{cancel:'開催中止',postpone:'開催延期',resume:'受付再開',correct:'実績訂正開始'});
    const values: Record<string,string> = { attended: '出席', attending: '出席予定', absent: '欠席', unanswered: '未回答', not_checked_in: '未登録', none: '条件なし', majority: '過半数', custom: '必要人数指定', ready: '開始前', open: '受付中', closed: '回答受付終了', finalized: '実績確定済み', cancelled: '中止' };
    const fields: Record<string,string> = { actualStatus: '当日実績', plannedStatus: '事前回答', isExcluded: '除外', answerDeadline: '回答期限', checkinStart: '受付開始', eventEnd: '受付終了', quorumMode: '成立条件', quorumTotal: '定数', quorumRequired: '必要人数', quorumRoleIds: '成立対象役職', target_count: '対象人数', roleId: '役職', status: '状態', sessions: '開催日程', attendanceMode: '受付方式', condition: '対象条件' };
    Object.assign(values,{postponed:'延期',correcting:'実績訂正中'});
    fields['answerResetDates']='回答を取り直す開催日';
    const display = (key: string, value: any): string => {
      if (value === undefined || value === null) return '未設定';
      if (key === 'isExcluded') return value ? '除外済み' : '対象';
      if (key === 'answerResetDates') return value.map((day: string) => this.dayLabel(day)).join('、') || 'なし';
      if (key === 'roleId') return this.additionRoles.find(r => r.id === value)?.name || String(value);
      if (key === 'quorumRoleIds' && Array.isArray(value)) return value.map(id => this.additionRoles.find(r => r.id === id)?.name || `旧設定 ${id}`).join('・') || '指定なし';
      if (key === 'plannedStatus' && value === 'absent') return '欠席予定';
      if (['answerDeadline','checkinStart','eventEnd'].includes(key)) return this.historyTime(String(value));
      return typeof value === 'object' ? JSON.stringify(value) : values[value] || String(value);
    };
    const before={...item.before};
    const after={...item.after};
    // 除外履歴に保存した所属・役職は識別情報であり、役職変更として表示しない。
    if (item.actionType === 'target_exclude') {
      for (const key of ['roleName','organizationName']) if (after[key] !== undefined && before[key] === undefined) before[key] = after[key];
    }
    fields['configurationSummary']='対象条件・開催日程';
    fields['roleName']='役職'; fields['organizationName']='所属';
    const changes = Object.keys(fields).filter(k => display(k,before[k]) !== display(k,after[k]))
      .map(k => `${fields[k]}：${display(k,before[k])} → ${display(k,after[k])}`);
    const name = item.targetName || item.after?.targetName;
    const day = item.after?.attendanceDate || item.before?.attendanceDate;
    return `${name ? '変更対象：' + name + ' ／ ' : ''}${day ? this.dayLabel(day) + ' ／ ' : ''}${types[item.actionType] || item.actionType}${changes.length ? ' ／ ' + changes.join('、') : ''}`;
  }

  historyTime(value: string): string { return value.replace('T',' ').slice(0,19); }
  dayLabel(day: string): string {
    return new Intl.DateTimeFormat('ja-JP', {year:'numeric',month:'long',day:'numeric',weekday:'short',timeZone:'Asia/Tokyo'}).format(new Date(day+'T00:00:00+09:00'));
  }
}
